import React from "react";
import { useNavigate } from "react-router-dom";

/**
 * FreeTrialComplete - 무료체험 신청 완료 페이지
 */
export function FreeTrialComplete() {
  const navigate = useNavigate();

  return (
    <div className="flex-1 flex items-center justify-center p-4">
      <div className="text-center max-w-2xl">
        <div className="mb-8">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-orange-100 rounded-full mb-6">
            <svg
              className="w-10 h-10 text-orange-500"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                fillRule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                clipRule="evenodd"
              />
            </svg>
          </div>
          <h1 className="text-4xl font-bold mb-4">무료체험 신청 완료</h1>
          <p className="text-xl text-gray-600 mb-8 leading-7">
            신청하신 무료체험이 완료되었습니다.
            <br />
            7일간의 AI 맞춤 학습을 즐겨보세요!
          </p>
        </div>

        <div className="bg-gray-50 rounded-lg p-8 mb-8">
          <div className="space-y-4 text-left">
            <div>
              <p className="text-gray-600 text-sm">무료체험 기간</p>
              <p className="text-lg font-medium">7일</p>
            </div>
            <div>
              <p className="text-gray-600 text-sm">체험 시작일</p>
              <p className="text-lg font-medium">오늘</p>
            </div>
          </div>
        </div>

        <div className="space-y-3">
          <button
            onClick={() => navigate("/login")}
            className="w-full h-14 bg-orange-500 text-white rounded-lg text-lg font-medium hover:bg-orange-600 transition-colors"
          >
            로그인하기
          </button>
          <button
            onClick={() => navigate("/")}
            className="w-full h-14 bg-gray-200 text-gray-800 rounded-lg text-lg font-medium hover:bg-gray-300 transition-colors"
          >
            홈으로 가기
          </button>
        </div>
      </div>
    </div>
  );
}
